import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { removeDvrRecording, fetchDvrRecordings } from 'store/actions';

// Import validation
import validation from './validation';

// Import components
import { Alert, Button, Field as FormField } from 'components/elements';

const RecordingsForm = ({
	closeModal,
	recordingId,
	isError,
	isLoaded,
	selectedDevice,
	removeDvrRecording,
	fetchDvrRecordings,
	errorMessage
}) => {
	const { t } = useTranslation();
	const form = useRef();

	useEffect(() => {
		if (isLoaded) {
			closeModal();
			form.current.resetForm();
		}
		// eslint-disable-next-line
	}, [isLoaded]);

	const handleOnSubmit = async ({ pin }) => {
		await removeDvrRecording(
			selectedDevice,
			recordingId,
			pin,
			() => form.current.resetForm(),
			() => fetchDvrRecordings(selectedDevice)
		);
	};

	return (
		<Formik
			ref={form}
			initialValues={{ pin: '' }}
			onSubmit={handleOnSubmit}
			validate={validation}
		>
			{({ handleSubmit, isSubmitting }) => (
				<form onSubmit={handleSubmit}>
					{isError && (
						<Alert
							closeBtn={false}
							text={errorMessage || t('user_profile_errors_connection')}
						/>
					)}

					<Field
						placeholder={t('user_profile_recordings_pin')}
						name="pin"
						type="text"
						component={FormField}
					/>
					<Button
						type="submit"
						disabled={isSubmitting}
						width="100%"
						modifiers="primary"
					>
						{t('user_profile_recordings_submit')}
					</Button>
				</form>
			)}
		</Formik>
	);
};

RecordingsForm.propTypes = {
	closeModal: PropTypes.func.isRequired,
	recordingId: PropTypes.string.isRequired,
	removeDvrRecording: PropTypes.func.isRequired,
	fetchDvrRecordings: PropTypes.func.isRequired,
	errorMessage: PropTypes.string.isRequired
};

const mapStateToProps = ({
	recordingsDvr: {
		remove: { isLoaded, isError, message }
	},
	devices: { selectedDevice }
}) => ({
	isError,
	isLoaded,
	errorMessage: message,
	selectedDevice
});

export default connect(
	mapStateToProps,
	{ removeDvrRecording, fetchDvrRecordings }
)(RecordingsForm);
